import { render } from "./RequestDemo.vue?vue&type=template&id=791a6afe"
import script from "./RequestDemo.vue?vue&type=script&lang=js"
export * from "./RequestDemo.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__